import { Component } from '@angular/core';
import { WithdrawData } from '../../transferhistory/models/transferhistory.model';
import { TransferService } from '../../transferhistory/services/transferhistory.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { decryptString } from 'src/app/lib/cryptoJs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-deposite-fiat-details',
  templateUrl: './deposite-fiat-details.component.html',
  styleUrls: ['./deposite-fiat-details.component.scss']
})
export class DepositeFiatDetailsComponent {
showModal = false;
  popupImageSrc = '';

  _id: any = ['']
  isLoading: boolean = false;
  withdrawData: any

  loader: boolean = false
  reason: string
  serverErrors: any = {}
  tokrn: any
  phoneNo: any = ''
  coinValue: any
  transactionId: any
  coinCurrentPrice: any
  usdtAmount: any

  depositImageUrl = environment.walletApiUrl + 'deposit/'

  constructor(
    private service: TransferService,
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private cookieService: CookieService,
  ) { }
  ngOnInit(): void {
    this.tokrn = this.cookieService.get('admin_token')
    const id = this.route.snapshot.params['id']
    this._id = decryptString(id, true)

    this.getData();
  }


  getData() {


    this.isLoading = true
    this.service.getFiatDeposits(this._id, this.tokrn).subscribe({
      next: (v: any) => {
        this.isLoading = false
        this.withdrawData = v.data.docs[0]
        localStorage.setItem("xyzy", this.withdrawData.phoneNo)
        this.coinValue = this.withdrawData.coinValue
        this.transactionId = this.withdrawData.transactionId
        this.coinCurrentPrice = this.withdrawData.coinCurrentPrice
        this.usdtAmount = this.withdrawData.usdtAmount

      },
      error: (err) => {
        this.isLoading = false
      }
    });
  }

  openImagePopup(imageUrl: string): void {
    this.popupImageSrc = imageUrl;
    this.showModal = true;
  }

  closeImagePopup(): void {
    this.showModal = false;
  }

  handleChange(event: any, name: string) {
    if (name == 'description') this.reason = event.target.value

    this.serverErrors = {}
  }



  approveCoinWithdraw() {
    this.loader = true
    this.service.approveRejectDeposit(this._id, 'approved', this.reason, this.tokrn)
      .subscribe({
        next: (resp: any) => {
          this.loader = false



          // Call nearMallsApiForCommision with the USDT amount

          const phoneno = localStorage.getItem('xyzy')
          this.service.nearMallsApiForCommision(
            phoneno,
            this.coinValue,
            this.transactionId,
            this.coinCurrentPrice


          ).subscribe({
            next: (response) => {

              this.toastr.success("commision is added to the nearmalls user")


            },
            error: (error) => {
              this.toastr.error('Comission Data is missing.');
              console.error('Transaction error:', error);
            }

          });

          if (resp.success) {
            this.toastr.success(resp.message)
            this.router.navigateByUrl('/deposite-commision')
          }
        },
        error: (err) => {
          this.loader = false
          if ([400, 404].includes(err.status)) {
            const validationErrors = err.error.errors;
            if (validationErrors) this.serverErrors = validationErrors || {};
            else this.toastr.error(err.error.message)
          } else if (err.status === 500) {
            this.toastr.error(err.error.message)
          }
        }
      })
  }

  rejectCoinWithdraw() {
    this.loader = true
    let reqData = {
      decryptData: this._id,
      reason: this.reason,
    }
    this.service.approveRejectDeposit(this._id, 'rejected', this.reason, this.tokrn)
      .subscribe({
        next: (resp: any) => {
          this.loader = false
          if (resp.success) {
            this.toastr.success(resp.message)
            this.router.navigateByUrl('/deposite-commision')
          }
        },
        error: (err) => {
          this.loader = false
          if ([400, 404].includes(err.status)) {
            const validationErrors = err.error.errors;
            if (validationErrors) this.serverErrors = validationErrors || {};
            else this.toastr.error(err.error.message)
          } else if (err.status === 500) {
            this.toastr.error(err.error.message)
          }
        }
      })
  }

  redirectToUser() {
    window.history.back();
  }

}

